import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ActionList from '@components/ActionsMenu/ActionList';
import {
  Content,
  ContextMenuStyled,
} from '@components/MainStage/ContextMenu/ContextMenu.styled';
import { clampMenuTopToPane } from '@components/MainStage/ContextMenu/helpers';
import { MenuStateWithItems } from '@components/MainStage/types';
import { SxProps } from '@mui/material';

export function ContextMenu({
  menuItems,
  top,
  left,
  position,
}: Readonly<Omit<MenuStateWithItems, 'id' | 'type'>> & {
  popoverSx?: SxProps;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [resolvedTop, setResolvedTop] = useState<number | false>(top);

  const isFixed = position === 'fixed';

  useLayoutEffect(() => {
    if (!isFixed || top === false) {
      setResolvedTop(top);
      return;
    }
    setResolvedTop(clampMenuTopToPane(top, ref.current));
  }, [isFixed, top, left, menuItems]);

  const content = (
    <ContextMenuStyled
      ref={ref}
      $top={isFixed ? resolvedTop : top}
      $left={left}
      $position={position}
    >
      <Content>
        <ActionList
          items={menuItems}
          popoverSx={{ '& .MuiPopover-paper': { borderRadius: '4px' } }}
        />
      </Content>
    </ContextMenuStyled>
  );

  return isFixed ? createPortal(content, document.body) : content;
}
